import * as React from "react";

import { FormControl, PhoneInput as Input } from "kanopi-components/Input";

import { WidthContainer } from "../../ChatFlow/WidthContainer";

type TAddressInputProps = {
  label?: string;
  title?: string;
  help?: string;
  error?: string;
};

export function PhoneInput(props: TAddressInputProps) {
  const { label, title, help, error, ...restProps } = props;
  return (
    <WidthContainer>
      <FormControl label={label} title={title} caption={help} error={error} forceFocus>
        <Input {...restProps} />
      </FormControl>
    </WidthContainer>
  );
}
